module.exports = __webpack_public_path__ + "img/screen1.b7f77379.jpg";